export default __webpack_public_path__ + "static/media/dehidden.91dae12a.svg";